export default "__VITE_ASSET__febdd336__"